import { from, of } from 'rxjs'
import { map, switchMap, toArray, take, groupBy, mergeMap, catchError } from 'rxjs/operators'

export default {
  data () {
    return {
      freeSearchCountries: ['IT', 'AT', 'CH', 'DE', 'FR', 'DK', 'FI', 'NO', 'SE']
    }
  },
  methods: {
    isFreeSearchEnabled () {
      const currentCountry = this.$store.state.config.country.toLowerCase()
      return this.freeSearchCountries
        .map(country => country.toLowerCase())
        .some(country => country === currentCountry)
    },
    onInputWIAAuto (value) {
      this.$store.commit('saveSearchString', {'searchString': value})

      const request$ = from(this.$http.post(
        `${this.$store.state.config.endpoint}/freeTextSearch`,
        // `https://api.wia.staging.wpsandwatch.com/freeTextSearch`,
        { productLineId: this.categorySelected.id, searchString: value, language: this.$store.state.config.language, country: this.$store.state.config.country, issue: this.getQueryStringValue('problemID') }
      ))
      request$
        .pipe(
          switchMap(response => from(response.body.items)),
          take(10),
          map(item => {
            if (Array.isArray(item.check_resolve_list)) {
              item.check_resolve_list = item.check_resolve_list.map(solution => ({ id: solution.check_resolve_id, verify: solution.resolve_text }))
            } else { item.check_resolve_list = [item.check_resolve_list] }
            return item
          }),
          groupBy(item => item.faultId_descr, item => item),
          mergeMap(group$ => group$.pipe(toArray(), map(items => ({ items, key: group$.key })))),
          toArray(),
          catchError(error => { this.error = error.body; console.log(error); return of([]) })
        )
        .subscribe(groups => {
          this.groups = groups
        })
    },
    onSelectWIAAuto (result) {
      this.$store.commit('saveGroups', {'groups': this.groups})
      // this.$store.commit('saveResultOptions', { 'resultOptions': result.check_resolve_list })
      this.$store.commit('saveSearchString', {'searchString': result.problemId_descr})

      this.$router.push({
        name: 'WIAResult',
        query: {
          productLine: this.categorySelected.text,
          product: '',
          macroCat: '',
          cat: '',
          problemID: result.problemId_lv3,
          problemName: result.problemId_descr,
          relatedProblemIDs: this.groups
            .flatMap(({ items }) => items)
            .map(item => item.problemId_lv3)
            .filter(code => code !== result.problemId_lv3)
            .join(',')
        }
      })
    },
    onResetWIAAuto () {
      this.$store.commit('saveGroups', {'groups': []})
      this.groups = []
    }
  }
}
